import { render, staticRenderFns } from "./ThemeTagSelector.vue?vue&type=template&id=00bc0514&scoped=true&"
import script from "./ThemeTagSelector.vue?vue&type=script&lang=js&"
export * from "./ThemeTagSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc0514",
  null
  
)

export default component.exports